import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react';
import clsx from 'clsx';
import styles from './SectionHeader.style';

const SectionHeader = ({
  as,
  noSpacing,
  noBorder,
  children,
  className: classNameProp,
  ...other
}) => {
  const className = clsx(
    styles.root,
    classNameProp,
    noSpacing && styles.noSpacing,
    noBorder && styles.noBorder,
  );

  return (
    <Text as={as} className={className} {...other}>
      {children}
    </Text>
  );
};

SectionHeader.propTypes = {
  as: PropTypes.string,
  noSpacing: PropTypes.bool,
  noBorder: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

SectionHeader.defaultProps = {
  as: 'h4',
  noSpacing: false,
  noBorder: false,
  children: '',
  className: '',
};

export default SectionHeader;
